<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading"
           @on-cancel="cancel"
           :class-name="z100000"
           :width="630"
    >
      <h3 slot="header" class="modal-header">角色列表</h3>
      <Table  ref="selection" :columns="columns" :height="500" :data="data" @on-selection-change="selectItem"></Table>
    </Modal>
  </div>


</template>
<script>
  import {rolelist} from "../../../../api/character";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      appType: {
        type: Number,
        default: 0
      },

    },
    watch:{
      n(){
        this.data=[]
        this.rolelistInfo()
        this.isShow=true
      }
    },
    data(){
      return {
        data:[],
        columns:[

          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '机构名称',
            key: 'orgName',
            align:'center'
          },
          {
            title: '所属应用',
            key: 'isZyuName',
            align:'center',
            // render: (h,params) => {
            //   return h('span',params.row.isZyu === '1' ? '自如寓':'超级ZO')
            // }

          },
          {
            title: '角色名称',
            key: 'roleName',
            align:'center'
          },
        ],
        z100000:'z100000',
        loading: true,
        isShow:false,
        selected:[]
      }
    },
    methods:{
      selectItem(value){
        this.selected=value
      },
      rolelistInfo(){
        let params={
          page:1,
          limit:100,
          appType:this.appType
        }
        rolelist(params).then(res=>{
          if(!res.data){
            return
          }
          this.data=res.data.rows
        }).catch(error=>{})
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        if(this.selected.length){
          let ids=[]
          this.selected.forEach(ele=>{
            ids.push(ele.id)

          })
          this.$emit('getRole',ids.join(','))

        }
        this.isShow=false

      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
